import { TRUNCATED_WIDTH } from "../constants";
export default {
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: TRUNCATED_WIDTH,
  minWidth: 20,
  color: "inherit"
};